import React from 'react';

interface Props {
  color?: string;
}

export default function CarouselChevron({ color }: Props) {
  return (
    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.03324 0.000406653C1.29268 0.00821023 1.53846 0.11746 1.71988 0.302795L11.7074 10.2914C12.0975 10.6815 12.0975 11.3136 11.7074 11.7038L1.71988 21.6924C1.47019 21.9538 1.09761 22.0592 0.746486 21.9675C0.397312 21.8758 0.124216 21.6026 0.0325336 21.2534C-0.0591488 20.9023 0.0461893 20.5297 0.307581 20.2799L9.58895 10.9976L0.307581 1.71524C0.0130272 1.42846 -0.076705 0.98951 0.083252 0.609085C0.245158 0.230612 0.621642 -0.011299 1.03324 0.000406653Z"
        fill={color}
      />
    </svg>
  );
}
